module.exports = __webpack_public_path__ + "img/media_13.d8b9a10f.jpg";